import { render, staticRenderFns } from "./WelcomeForm.vue?vue&type=template&id=0d5bcc7a&scoped=true&"
import script from "./WelcomeForm.vue?vue&type=script&lang=js&"
export * from "./WelcomeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5bcc7a",
  null
  
)

export default component.exports